const videoPlayer = () => {
  const playBtn = $('.video-player .play-btn');
  const muteBtn = $('.video-player .mute-btn');

  function playHandler() {
    const video = $(this).siblings('video')[0];
    $(this).removeClass('initial-position');
    if (!$(this).hasClass('is-pause')) {
      $(this).addClass('is-pause');
      video.play();
    } else {
      $(this).removeClass('is-pause');
      video.pause();
    }
  }

  function muteHandler() {
    const video = $(this).siblings('video')[0];
    if (!$(this).hasClass('is-unmute')) {
      $(this).addClass('is-unmute');
      video.muted = false;
    } else {
      $(this).removeClass('is-unmute');
      video.muted = true;
    }
  }

  function endedHandler() {
    const video = $(this)[0];
    const playBtn = $(this).siblings('.play-btn');
    playBtn.addClass('initial-position');
    playBtn.removeClass('is-pause');
    video.pause();
    video.currentTime = 0;
  }

  $('.video-player video').on('ended', endedHandler);
  playBtn.on('click', playHandler);
  muteBtn.on('click', muteHandler);
};

export default videoPlayer;
